import axios from "axios";
import helpers from "./helpers";

async function requestTTS(configs) {
    // return new Promise((resolve, reject) => {
    //     try {
    //         if (typeof configs.params === "undefined") configs["params"] = {};
    //         configs.params["timestamp"] = Math.floor(Date.now() / 1000)
    //         configs.params["app_key"] = TTS_app_key
    //         configs.params['sign'] = generateSign(configs);
    //         axios.request(configs)
    //             .then((response) => {
    //                 return resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //                 return reject(error);
    //             });
    //     } catch (e) {
    //         console.log(e);
    //         return reject(e);
    //     }
    // })
}

const LOGIN = "/users/login";
const REGISTER = "/users/register";
const AUTH_CHECK = "/users/check";
const SHOP_LIST = "/api/shop/list";
const SUGGEST_CATEGORY = "/api/shop/suggest-category";
const GET_ATTRIBUTES = "/api/shop/attributes";
const CONNECT_SHOP_LINK = "/api/shop/get-connect-link";

const apiServices = {
    login: async function (loginObj) {
        console.log(axios.defaults)
        try {
            let data = JSON.stringify(loginObj);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: LOGIN,
                data: data
            };
            const login_rs = await axios.request(config);
            return login_rs.data;
        } catch (e) {
            console.log(e)
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    },
    register: async function (loginObj) {
        try {
            let data = JSON.stringify(loginObj);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: REGISTER,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            const login_rs = await axios.request(config);
            return login_rs.data;
        } catch (e) {
            console.log(e)
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    },
    authCheck: async function (loginObj) {
        try {
            const checkRS = await axios.get(AUTH_CHECK);
            return checkRS.data;
        } catch (e) {
            console.log(e)
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    },
    shopList: async function () {
        const checkRS = await axios.get(SHOP_LIST);
        return checkRS.data;
    },
    getConnectShopLink: async function (connectObj) {
        try {
            let data = JSON.stringify(connectObj);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: CONNECT_SHOP_LINK,
                data: data
            };
            const connectLinkRS = await axios.request(config);
            return connectLinkRS.data;
        } catch (e) {
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    },
    suggestCategory: async function (title, shop_id) {
        try {
            let data = JSON.stringify({title, shop_id});
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: SUGGEST_CATEGORY,
                data: data
            };
            return await axios.request(config);
        } catch (e) {
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    },
    getAttributes: async function (category_id, shop_id) {
        try {
            let data = JSON.stringify({category_id, shop_id});
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: GET_ATTRIBUTES,
                data: data
            };
            return await axios.request(config);
        } catch (e) {
            return helpers.responseMessage.error(e?.message ?? "Unknown error!")
        }
    }
}
export default apiServices;